import { Controller } from "react-hook-form";
import AutoCompleteField from "./auto-complete-field";

const AutoCompleteFormField = (props) => {
  const { name, defaultValue = null, control } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <AutoCompleteField
            {...props}
            value={value}
            onChange={(e, val) => {
              onChange(val);
            }}
            error={error}
          />
        );
      }}
    />
  );
};

export default AutoCompleteFormField